import React, { useState, useEffect } from "react";
import { Box, Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { Stack } from "@mui/system";

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "true");
    setShowBanner(false);
  };

return showBanner ? (
  <Box
    sx={{
      position: "fixed",
      bottom: 0,
      left: 0,
      width: "100%",
      backgroundColor: "#0c6b8bd6",
      color: "white",
      padding: "16px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      zIndex: 9999,
    }}
  >
    {" "}
    <Typography variant="h6">
      Questo sito utilizza i cookie per migliorare l'esperienza utente.
      Continuando la navigazione, accetti l'uso dei cookie.
    </Typography>
    <Stack gap={1} flexDirection={"row"}  justifyItems={'end'}>
      <Button variant="contained" color="info" onClick={handleAccept}>
        Accetto
      </Button>
      <Link
        style={{ borderBottom: "0.2px solid red", textDecoration: "none" }}
        to="/privacy-policy"
      >
        {" "}
        <Button variant="contained" color="info">
          {" "}
          Privacy Policy
        </Button>
      </Link>
    </Stack>
  </Box>
) : null;

};

export default CookieConsent;
